import { useEffect, useState } from "react";

/**
 * Hook PRO pour détecter si l'utilisateur est sur mobile/tablette
 * Breakpoint: < 1024px = mobile/tablette
 * >= 1024px = desktop
 */
export const useDeviceDetection = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 1024 : false
  );

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Vérification initiale
    checkDevice();

    // Écouter les changements de taille
    window.addEventListener("resize", checkDevice);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);

  return { isMobile };
};
